import { fetchFutureDetails } from '../api/api';
import { useQuery} from 'react-query'
import { useState, useEffect } from 'react';

export const useFutureDetailsQuery = (slug) => {
    const { isLoading, data, isError } = useQuery([slug], () => fetchFutureDetails(slug), {enabled: !!slug, retry: false });
    const [futureDetails, setFutureDetails] = useState();

    useEffect(() => {
        if (data && !isError) {
            setFutureDetails(data);
        }
    }, [data, isLoading]);

    return { isLoading, futureDetails, isError };
}